import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { SITE_NAV_ROUTES } from "../../../constants/siteNavRoutes";
import imgGame from "../../../assets/img/treydora_redesign/homepage/cardimage.webp";
import imgToken from "../../../assets/img/treydora_redesign/brand/treydorex coin.webp";
import imgComic from "../../../assets/img/treydora_redesign/homepage/NFTComic.webp";
import imgBook from "../../../assets/img/treydora_redesign/homepage/Book.webp";
import whitepaperPdf from "../../../lib/whitepaperPdf";
import { trackHomepageCtaClick, trackNftComicCtaClick } from "../../../utils/analytics";

const cards = [
  {
    title: "THE GAME",
    blurb:
      "A living open world where factions clash, economies breathe, and your choices echo across Oshar.",
    img: imgGame,
    icon: "fas fa-dragon",
    cta: "ENTER THE GAME",
    to: SITE_NAV_ROUTES.WORLD,
  },
  {
    title: "TREYDOREX",
    blurb:
      "The utility token powering access, upgrades, and participation across Treydora experiences.",
    img: imgToken,
    mediaClass: "td-rpg-card__media--token",
    icon: "fas fa-coins",
    cta: "EXPLORE TOKEN",
    to: SITE_NAV_ROUTES.TOKEN_SALE,
    hashLink: true,
  },
  {
    title: "NFT COMIC BOOK",
    blurb:
      "Collect Koraxos on-chain—comic-grade art, holder perks, and story that expands the universe.",
    img: imgComic,
    icon: "fas fa-book-open",
    cta: "VIEW COMIC",
    to: SITE_NAV_ROUTES.PUBLIC_LIBRARY,
  },
  {
    title: "THE NOVEL",
    blurb:
      "Deep lore and prose canon—download the whitepaper bundle and follow the saga from the first page.",
    img: imgBook,
    icon: "fas fa-scroll",
    cta: "BUY THE BOOK",
    externalPdf: true,
  },
];

const HomeRpgFeatureCards = () => {
  const trackCardCta = (card) => {
    const eventParams = {
      cta_id: `feature_${String(card.cta || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "")}`,
      section: "feature_cards",
      label: card.cta,
      destination: card.to || "whitepaper",
    };

    if (card.title === "NFT COMIC BOOK") {
      trackNftComicCtaClick(eventParams);
      return;
    }

    trackHomepageCtaClick(eventParams);
  };

  return (
    <section className="td-rpg-section" id="features" aria-labelledby="td-features-heading">
      <div className="td-rpg-inner">
        <div className="td-rpg-section__head">
          <div className="td-rpg-ornament" />
          <p className="td-rpg-section__kicker" id="td-features-heading">
            CHOOSE YOUR PATH
          </p>
          <h2 className="td-rpg-section__title">FORGE YOUR LEGACY</h2>
        </div>
        <div className="td-rpg-cards">
          {cards.map((c) => (
            <article key={c.title} className="td-rpg-card">
              <div className={`td-rpg-card__media${c.mediaClass ? ` ${c.mediaClass}` : ""}`}>
                <img
                  src={c.img}
                  alt={`${c.title} — Treydora universe`}
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="td-rpg-card__icon">
                <i className={c.icon} aria-hidden />
              </div>
              <h3>{c.title}</h3>
              <p>{c.blurb}</p>
              {c.externalPdf ? (
                <a
                  href={whitepaperPdf}
                  download="treydorawhitepaper"
                  className="td-btn-outline"
                  style={{ display: "block", textAlign: "center" }}
                  onClick={() => trackCardCta(c)}
                >
                  {c.cta}
                </a>
              ) : c.hashLink ? (
                <HashLink
                  smooth
                  to={c.to}
                  className="td-btn-outline"
                  style={{ display: "block", textAlign: "center" }}
                  onClick={() => trackCardCta(c)}
                >
                  {c.cta}
                </HashLink>
              ) : (
                <Link
                  to={c.to}
                  className="td-btn-outline"
                  style={{ display: "block", textAlign: "center" }}
                  onClick={() => trackCardCta(c)}
                >
                  {c.cta}
                </Link>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeRpgFeatureCards;
